import React from "react";

import { Label, Select } from "@busbud/horizon";

import { useAppContext } from "@app/helpers/hooks";

import { Locales } from "../../../../../../config/locales";

interface Props {
  user_locale: string;
  onChange: (new_value: { locale: string }) => void;
}

export const LanguageSection: React.FC<Props> = ({ user_locale, onChange }) => {
  const { translator } = useAppContext();
  const selected_language = user_locale === "en" ? "en-us" : user_locale;

  const handleLanguageChange = (evt: React.ChangeEvent<{ value: string }>) => {
    onChange({ locale: evt.target.value });
  };

  return (
    <div className="flex flex-col gap-200">
      <Label fontWeight="bold" size="lg" as="span" className="flex-grow">
        {translator.t("!accounts.email-language.title")}
      </Label>

      <Select
        labelText={translator.t("!accounts.edit-profile.language")}
        defaultValue={selected_language}
        onChange={handleLanguageChange}
        className="w-full"
      >
        {Object.values(Locales.supported_locales).map(locale_params => {
          const value = locale_params.full_locale;

          return (
            <Select.Option key={value} value={value}>
              {locale_params.label}
            </Select.Option>
          );
        })}
      </Select>
    </div>
  );
};
